<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div
			class="w-100 overflow-hidden"
			:class="(windowWidth<=1000)? 'h-center': ''"
		>
			<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-3">
				<div class="row">
					<div class="col-6 bold p-3">
						تیکت های شما
					</div>
					<div class="col-6 text-left p-3">
						<span 
						class="pointer"
						@click="$router.go(-1)" 
						style="color:#676767; font-size:12px;"
						v-if="(windowWidth>1000)"
						>
							بازگشت به فهرست تیکت ها	&nbsp;	
							<img 
							:src="require('../../assets/img/Arrow_Down.svg')"
							width="16"
							style="rotate: 90deg;"
							/>
						</span>
						<span 
						class="pointer"
						@click="$router.go(-1)" 
						style="color:#676767; font-size:12px;"
						v-else
						>
							<img 
							:src="require('../../assets/img/Arrow_Down.svg')"
							width="16"
							style="rotate: 90deg;"
							/>
						</span>
					</div>
				</div>
				<part1 :flds="flds" @loader="loader()" />
				<div class="pt-3 pb-3"
				v-if="$localStorage.get('user').username.role!=3 || ($localStorage.get('user').username.role=3 && flds.data.read_crm != 4)"
				>
					<b>
						پاسخ به تیکت
					</b>
				</div>
				<part11 :flds="flds" @loader="loader()" v-if="flds.data.read_crm != 4"  />
				<part12 :flds="flds" @loader="loader()" v-else-if="$localStorage.get('user').username.role!=3" />
			</div>
			<div class="col-lg-3 col-md-3 float-left"  v-if="windowWidth>1000">
				<part2 select="17" />
			</div>
		</div>
		<footerPage />
	</div>
</template>

	<script>
		import part1 from  "./part1.vue";
		import part11 from  "./part11.vue";
		import part12 from  "./part12.vue";
		import headMenu from  "../../menu/headMenu.vue";
		import part2 from  "../../USER/reserved_user_list/part2.vue";
		import footerPage from  "../../USER/public/home/home_part9.vue";
		export default {
			name: 'tick_id',
			data(){
				return {
					flds: [],
				}
			},
			components: {
				headMenu,
				part1,
				part11,
				part12,
				part2,
				footerPage,
			},
			props: [],
			computed :{
			},
			mounted(){
				if(this.$localStorage.get('user')==null){
					this.$localStorage.set('urlPath', window.location.pathname);
					this.$router.push('/login');
				}else{
					this.loader();					
				}
			},
			methods:{
				//*********************************************
				loader(THIS=this){
					window.$.post(window.baseurl+'ticket/'+this.$route.params.id, {
						token: this.$localStorage.get("user")
					}, function(D){
						
						if(D.status.code == 401){
							THIS.$localStorage.remove('user');
							THIS.$router.replace('/oneTimePassword');
						} else if(D.data.length==0){
							THIS.$router.push('/ticket/list');
						}else{
							THIS.flds = D;
						}
					}, "json");
				},
				//*********************************************
			}
		}
	</script>
<style>

</style>
